export const CARD_FORM = {
  cardForm: document.querySelector('#aafp_add-new-card') as HTMLFormElement,
  cardPartner: document.querySelector('#aafp_dropdown-button-partner') as HTMLElement,
  cardCustomer: document.querySelector('#aafp_dropdown-button-customer') as HTMLElement,
  cardCardGroup: document.querySelector('#aafp_dropdown-button-card-group') as HTMLElement,
  cardNames: document.querySelector('#aafp_form-card-name') as HTMLTextAreaElement,
  cardDriverPins: document.querySelector('#aafp_form-driver-pin') as HTMLTextAreaElement,
  cardSubmitButton: document.querySelector('#aafp_new-card-submit') as HTMLButtonElement,
  cardNumber: document.querySelector('#aafp_form-card-number') as HTMLInputElement,
  cardTransaction: document.querySelector('#aafp_form-card-transaction') as HTMLInputElement,
  cardStatus: document.querySelector('#aafp_dropdown-button-active') as HTMLElement,
  printButton: document.querySelector('#download-print-file') as HTMLElement
}

export const CARD_FORM_STATUS = [
  { id: 0, name: 'Inactive' },
  { id: 1, name: 'Active' },
]